import React, {useState} from "react";
import Alert from "react-bootstrap/Alert";
import {formatDeliveryStatus, formatDeliveryStatusColor} from "./constants";
import {Button, Col, Modal, Row} from "react-bootstrap";
import {TransferInfo} from "./TransferInfo";
import {FaTruck} from "react-icons/fa";
import {checkPermission} from "../../../../../_helpers/commonFunctions";
import {openTabByType} from "../../../../../_helpers/tabOpeners";
import {useDispatch, useSelector} from "react-redux";
import {setAutoTransfer} from "../../../../../_reducers/DataPanel/Sales/transfersSlice";
import {selfUpdateSaleByMark} from "../../../../../_helpers/tabUpdater";

const SalesViewTransfer = ({saleObj}) => {
    const dispatch = useDispatch();
    const [show, setShow] = useState(false);
    const permissionsData = JSON.parse(localStorage.getItem("permissions"));
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const editSales = useSelector((state) => state.SALES.editSales);

    const handleAdd = () => {
        dispatch(openTabByType("new-transfer", TABS_DATA));
        dispatch(setAutoTransfer(saleObj.transfer));
    }

    return (
        <React.Fragment>
            {(saleObj.transfer && checkPermission("custom-deliverynote", permissionsData)) && (
                <React.Fragment>
                    <Alert variant={"secondary mb-1"}>
                        <Row>
                            <Col md={8}>
                                <div className={"mb-1"}>Το παρόν παραστατικό αποτελεί παραστατικό διακίνησης.</div>
                                <strong>Κατάσταση Διακίνησης:</strong>
                                <span style={{
                                    borderRadius: "6px",
                                    padding: "3px",
                                    backgroundColor: formatDeliveryStatusColor(saleObj.transfer.myDataStatus),
                                }} className={"ml-2"}>
                                    {formatDeliveryStatus(saleObj.transfer.myDataStatus)}
                                </span>
                            </Col>
                            <Col md={4} className={"d-flex justify-content-end"}>
                                <Button size={"sm"} className={"mr-1"} onClick={() => handleAdd()}>
                                    Μεταφορά στον πίνακα διακινήσεων
                                </Button>
                                <Button size={"sm"} onClick={() => setShow(true)}>
                                    Προβολή λεπτομερειών Διακίνησης <FaTruck size={18} className={"ml-1"} />
                                </Button>
                            </Col>
                        </Row>
                    </Alert>

                    <Modal show={show} onHide={() => setShow(false)} dialogClassName={"modal65PercentWidth"}>
                        <Modal.Header closeButton>
                            <Modal.Title>Λεπτομέριες Διακίνησης</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <TransferInfo
                                transferData={saleObj.transfer}
                                refreshCallback={() => {
                                    selfUpdateSaleByMark(dispatch, editSales, company.id, saleObj.mark);
                                }}
                            />
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="outline-primary" onClick={() => setShow(false)}>
                                Κλείσιμο
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default SalesViewTransfer;
